module.exports = __webpack_public_path__ + "img/download-ja.6fb3d95c.png";